import React from "react";
import { T } from "./tokens";

/**
 * The one bespoke-CSS element in this redesign (per the handoff): a circular
 * completeness ring built from a conic-gradient. Not a stock MUI component.
 */
const CompletenessRing: React.FC<{ pct: number }> = ({ pct }) => {
  const p = Math.max(0, Math.min(100, Math.round(pct)));
  return (
    <div
      style={{
        width: 128,
        height: 128,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        background: `conic-gradient(${T.gold} 0% ${p}%, rgba(255,255,255,.16) ${p}% 100%)`,
      }}
    >
      <div
        style={{
          width: 96,
          height: 96,
          borderRadius: "50%",
          background: T.greenRingInner,
          display: "grid",
          placeItems: "center",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ fontWeight: 800, fontSize: 26, lineHeight: 1, color: "#fff" }}>
            {p}%
          </div>
          <div
            style={{
              fontWeight: 600,
              fontSize: 8.5,
              color: "rgba(255,255,255,.65)",
              letterSpacing: ".1em",
              marginTop: 3,
            }}
          >
            COMPLETE
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletenessRing;
